const styles = () => ({
  errorBoundry: {
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
});

export default styles;
